import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { DirectRoutingModule } from "./direct-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DirectComponent } from "./page/direct/direct.component";
import { ScraiiAiComponent } from "./page/scraii-ai/scraii-ai.component";
import { ScraiiControlChartComponent } from "./page/scraii-ai/control-chart/scraii-control-chart.component";
import { ScraiiGanttChartComponent } from "./page/scraii-ai/gantt-chart/scraii-gantt-chart.component";
import { MatComponentsModule } from "src/app/mat-components.module";
import { AgGridModule } from "ag-grid-angular";
import { DashboardModule } from "../dashboard/dashbaord.module";
import { WorkflowManagementComponent } from "./page/workflow-management/workflow-management.component";
import { WorkflowActionDialogComponent } from "./components/workflow-action-dialog/workflow-action-dialog.component";
import { WorkflowLogsDialogComponent } from "./components/workflow-logs-dialog/workflow-logs-dialog.component";
import { WorkflowDesignerComponent } from "./components/workflow-designer/workflow-designer.component";
import { ExtendedModule } from "@angular/flex-layout";
import { DynamicEmailTableComponent } from "./components/dynamic-email-table/dynamic-email-table.component";
import { EmailTemplateDesignerComponent } from "./page/email-template-designer/email-template-designer.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkMenuModule } from "@angular/cdk/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { EmailExtractsComponent } from "./page/email-extracts/email-extracts.component";
import { ChartsModule } from "src/app/components/shared/charts/charts.module";
import { WidgetModule } from "../widget/widget.module";
import { TaskDetailPageComponent } from "./page/task-detail/task-detail.component";
import { MarkdownRenderPipe } from "src/app/pipe/markdown-render.pipe";
// The entire Case Management feature (board, dialog, cell renderers, subtask
// sidebar subtree) now lives in TaskPanelModule so the same board can also be
// hosted globally from the topnav. DirectModule consumes it via this import —
// DirectComponent + TaskDetailPageComponent still reference those components
// through TaskPanelModule's exports.
import { TaskPanelModule } from "./task-panel.module";
import { ColumnDisplayNamePipe } from "src/app/pipe/column-display-name.pipe";

@NgModule({
  declarations: [
    DirectComponent,
    ScraiiAiComponent,
    ScraiiControlChartComponent,
    ScraiiGanttChartComponent,
    WorkflowManagementComponent,
    WorkflowActionDialogComponent,
    WorkflowLogsDialogComponent,
    WorkflowDesignerComponent,
    DynamicEmailTableComponent,
    EmailTemplateDesignerComponent,
    EmailExtractsComponent,
    TaskDetailPageComponent,
    MarkdownRenderPipe,
    ColumnDisplayNamePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DirectRoutingModule,
    DashboardModule,
    AgGridModule,
    MatComponentsModule,
    ExtendedModule,
    DragDropModule,
    CdkMenuModule,
    NgSelectModule,
    ChartsModule,
    WidgetModule,
    TaskPanelModule,
  ],
  exports: [DirectComponent, ScraiiAiComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DirectModule { }
